import { createSelector } from 'reselect';

const selectShippingProviders = (state: any) => state.shippingProviders;


export const selectShippingProvidersCurrentItem = createSelector([selectShippingProviders], (shippingProviders) => shippingProviders.current);

export const selectShippingProvidersListItems = createSelector([selectShippingProviders], (shippingProviders) => shippingProviders.list);

export const selectShippingProvidersItemById = (itemId: any) =>
    createSelector(selectShippingProvidersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectShippingProvidersQueryItems = createSelector([selectShippingProviders], (shippingProviders) => shippingProviders.query);

export const selectShippingProvidersCreatedItem = createSelector([selectShippingProviders], (shippingProviders) => shippingProviders.create);

export const selectShippingProvidersUpdatedItem = createSelector([selectShippingProviders], (shippingProviders) => shippingProviders.update);

export const selectShippingProvidersReadItem = createSelector([selectShippingProviders], (shippingProviders) => shippingProviders.read);

export const selectShippingProvidersDeletedItem = createSelector([selectShippingProviders], (shippingProviders) => shippingProviders.delete);

export const selectShippingProvidersSearchedItems = createSelector([selectShippingProviders], (shippingProviders) => shippingProviders.search);

export const selecShippingProvidersItemsCount = createSelector([selectShippingProviders], (shippingProviders) => shippingProviders.count);

export const selecShippingProvidersItemsFilter = createSelector([selectShippingProviders], (shippingProviders) => shippingProviders.filter);